module.exports = __webpack_public_path__ + "static/media/photo.b8af8e5a.png";